export default __webpack_public_path__ + "static/media/TER2.1f653505.jpg";